import { defineComponent, computed } from "vue";
import { u as useFixedBarProps, a as useFixedBar } from "../../composables/useFixedBar-e6acac44.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { s as setupScroll } from "../../composables/useScroll-41119ddc.mjs";
import { u as useColors } from "../../composables/useColors-cd2c0b98.mjs";
import { u as useTextColor } from "../../composables/useTextColor-19f6bd95.mjs";
const _sfc_main = defineComponent({
  name: "VaNavbar",
  props: {
    ...useFixedBarProps,
    ...useComponentPresetProp,
    color: { type: String, default: "background-secondary" },
    textColor: { type: String },
    shape: { type: Boolean, default: false }
  },
  setup(props) {
    const { scrollRoot, isScrolledDown } = setupScroll(props.fixed);
    const { fixedBarStyleComputed } = useFixedBar(props, isScrolledDown);
    const { getColor, shiftHSLAColor } = useColors();
    const { textColorComputed } = useTextColor();
    const color = computed(() => getColor(props.color));
    const shapeStyleComputed = computed(() => ({
      borderTopColor: shiftHSLAColor(color.value, { h: -1, s: -11, l: 10 })
    }));
    const computedStyle = computed(() => ({
      ...fixedBarStyleComputed.value,
      backgroundColor: color.value,
      color: textColorComputed.value,
      fill: textColorComputed.value
    }));
    return {
      scrollRoot,
      computedStyle,
      shapeStyleComputed
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaNavbar.vue_vue_type_script_lang-1b15d5ff.mjs.map
